// extracted by mini-css-extract-plugin
export default {"title":"Title_title__eSDz5","titleBorder":"Title_titleBorder__mij1O"};